import httpClient from 'httpClient'
import DateTimeHelper from 'helpers/date'
import { getBaseUrls } from 'helpers/baseURLhelper'

const CATEGORIES_ENDPOINT = '/public/categories'
const CHANNELS_ENDPOINT = '/public/channels'
const EPG_ENDPOINT = '/public/events/epg'
const EVENTS_ENDPOINT = '/public/events'

// Epg Service
export default {
  getTvCategories: function (payload) {
    return httpClient.get(getBaseUrls('baseApi') + '/' + process.env.API_VER + CATEGORIES_ENDPOINT, {
      params: {
        type: 'TV',
        ...payload
      }
    })
  },
  getRadioCategories: function (payload) {
    return httpClient.get(getBaseUrls('baseApi') + '/' + process.env.API_VER + CATEGORIES_ENDPOINT, {
      params: {
        type: 'RADIO',
        ...payload
      }
    })
  },
  getTvChannels: function (payload) {
    return httpClient.get(getBaseUrls('baseApi') + '/' + process.env.API_VER + CHANNELS_ENDPOINT, {
      params: {
        channelType: 'TV',
        ...payload
      }
    })
  },
  getRadioChannels: function (payload) {
    return httpClient.get(getBaseUrls('baseApi') + '/' + process.env.API_VER + CHANNELS_ENDPOINT, {
      params: {
        channelType: 'RADIO',
        ...payload
      }
    })
  },
  getEpg: function (payload) {
    // Get start of seventh day before now in ISO format
    let fromTime = DateTimeHelper.format(DateTimeHelper.getStartOfDay() - DateTimeHelper.daysToMs(7))
    // Get end of third day after now in ISO format
    let toTime = DateTimeHelper.format(DateTimeHelper.getEndOfDay() + DateTimeHelper.daysToMs(3))
    return httpClient.get(getBaseUrls('baseApi') + '/' + process.env.API_VER + EPG_ENDPOINT, {
      params: {
        fromTime: fromTime,
        toTime: toTime,
        ...payload
      }
    })
  },
  getEvents: function (payload) {
    return httpClient.get(getBaseUrls('baseApi') + '/' + process.env.API_VER + EVENTS_ENDPOINT, {
      params: {
        channelSort: 'RECOMMENDED',
        sortDir: 'ASC',
        size: 20,
        ...payload
      }
    })
  },
  getEvent: function (eventId, payload) {
    return httpClient.get(getBaseUrls('baseApi') + '/' + process.env.API_VER + EVENTS_ENDPOINT + '/' + eventId, {
      params: {
        ...payload
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/epg/index.js